import React from 'react';
import { useSelector } from 'react-redux';
import { Copy } from 'e4shared';
import Subheader from 'components/prism/subheader';
import { Metric } from '../metric';
import Toggle from 'components/prism/toggle';

export const MetricsGrid = ({ metrics, text, setPeriod, period }) => {
    const showMoreValue = 4;
    const showMoreLessAvaialable = metrics.length > showMoreValue;
    const [loading, setLoading] = React.useState(false);
    const { prismMultiColumn } = useSelector(state => state.ui);
    const [showMoreLess, setShowMoreLess] = React.useState(false);
    const [visibleMetrics, setVisibleMetrics] = React.useState([]);

    React.useEffect(() => {
        if (showMoreLess) {
            setVisibleMetrics(metrics);
        } else {
            setVisibleMetrics(metrics.slice(0, showMoreValue));
        }
    }, [showMoreLess, metrics]);

    const extra = (
        <Toggle value={period} onChange={setPeriod}>
            <button value="W">{text.periods.week}</button>
            <button value="M">{text.periods.month}</button>
            <button value="Q">{text.periods.quarter}</button>
        </Toggle>
    );

    return (
        metrics.length > 0 && (
            <div className="mt30">
                <h6 className="mt20">
                    <Subheader title={text.title} count={metrics.length} extra={extra} />
                </h6>
                <p className="mb10">
                    <Copy value={text.description} />
                </p>

                {metrics.length === 1 ? (
                    <Metric key={`metric-${metrics[0].id}`} metric={metrics[0]} loading={loading} period={period} />
                ) : (
                    <div className={prismMultiColumn ? 'even-col' : 'one-col'}>
                        {visibleMetrics.map(metric => {
                            return <Metric key={`metric-${metric.id}`} metric={metric} loading={loading} period={period} />;
                        })}
                    </div>
                )}

                {showMoreLessAvaialable && (
                    <button
                        className="btn btn-primary btn-rounded mt20"
                        onClick={() => setShowMoreLess(!showMoreLess)}
                        style={{ display: showMoreLessAvaialable ? 'block' : 'none' }}
                    >
                        {showMoreLess ? 'Show Less' : 'Show More'}
                    </button>
                )}
            </div>
        )
    );
};

export default MetricsGrid;
